export function MapaSkeleton() {
    return (
        <div className="rounded-xl border border-violet-300 bg-white overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-2 border-b border-violet-200">
                <span className="text-sm font-semibold text-violet-900 uppercase">Mapa</span>
                <div className="flex items-center gap-3 text-xs">
                    <span className="inline-flex items-center gap-1 text-gray-700">
                        <span className="inline-block h-3 w-3 rounded-full bg-gray-400" /> Libre
                    </span>
                    <span className="inline-flex items-center gap-1 text-gray-700">
                        <span className="inline-block h-3 w-3 rounded-full bg-gray-700" /> Ocupado
                    </span>
                    <span className="inline-flex items-center gap-1 text-gray-700">
                        <span className="inline-block h-3 w-3 rounded-full bg-emerald-500" /> Tu selección
                    </span>
                </div>
            </div>

            {/* Contenedor del mapa - igual al real */}
            <div className="p-3">
                <div
                    className="relative bg-gray-100 rounded-md flex items-center justify-center"
                    style={{ minHeight: 260 }}
                >
                    {/* Indicador de carga */}
                    <div className="flex flex-col items-center gap-3 text-gray-500">
                        <svg className="animate-spin h-8 w-8 text-violet-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <span className="text-sm">Cargando disponibilidad...</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
